<style scoped>

.projects {
    margin-top: 0px;
}

</style>

<template>
<div class="projects">
    <v-container fluid grid-list-lg grid-list-md>
        <v-layout row wrap>
          <h2 class="font-weight-thin">{{ projects.length }} Projects </h2>
        </v-layout>
        <v-layout row wrap style="position: relative">
          <v-dialog v-model="dialog.open" persistent max-width="600px">

              <v-btn slot="activator" color="pink" dark small absolute top right fab>
                  <v-icon>add</v-icon>
              </v-btn>
              <form id="add-project-form" @submit.prevent="submit()">
              <v-card>
                  <v-card-text>
                      <v-container grid-list-md>
                          <v-layout wrap>
                              <v-flex xs12 sm12 md12>
                                  <v-text-field name="name" label="Project Name*" v-model="project.name" v-validate="'required'" :error-messages="errors.collect('name')"></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                  <v-textarea name="description" v-model="project.description" label="Project Description*" v-validate="'required'" :error-messages="errors.collect('description')"></v-textarea>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                  <v-text-field name="prefix" label="Prefix *" v-model="project.prefix" v-validate="'required'" :error-messages="errors.collect('prefix')"></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6>
                                  <v-text-field name="bucket" label="Bucket Name" v-model="project.bucket"></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6>
                                  <v-text-field name="region" label="Bucket Region" v-model="project.region"></v-text-field>
                              </v-flex>
                          </v-layout>
                      </v-container>
                      <small>*indicates required field</small>
                  </v-card-text>
                  <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click="mCloseDialog()">Close</v-btn>
                      <v-btn color="blue darken-1" type="submit" form="add-project-form" flat>{{ dialog.text }}</v-btn>
                  </v-card-actions>
              </v-card>
            </form>
          </v-dialog>
    <v-flex xs12 sm6 md4 lg3  v-for="(item, index) in projects" :key="index">
            <v-card  style="padding: 30px"  :to="{name: 'datasources', params: {projectId: item.id}}" target="_blank">
                <v-btn fab dark small color="purple">
                  {{ item.name.substring(0, 1) }}
                </v-btn><br />
                  <h1>
                  <v-list-tile-sub-title class='text--primary'>
                      {{ item.name }}
                  </v-list-tile-sub-title>
                </h1>
                  <v-list-tile-sub-title>
                      {{ item.description }}
                  </v-list-tile-sub-title>

            </v-card>
    </v-flex>
  </v-layout>
    </v-container>
</div>

</template>

<script>

import ProjectItem from '@/components/ProjectItem.vue'
import {createNamespacedHelpers} from 'vuex'
const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('projects');


const dataSourceNamespace = createNamespacedHelpers('dataSources');
export default {
    name: 'projects',
    data: function() {
        return {

        }
    },
    components: {
        'project-item': ProjectItem
    },
    computed: {
      ...mapState(['projects', 'project', 'dialog'])
    },
    methods: {
      ...mapMutations(['mAdd', 'mCloseDialog']),
      ...mapActions(['aAdd', 'aInit']),
      submit() {
        const add = this.aAdd;
        const project = this.project;
        this.$validator.validateAll().then(function(response) {
          if(response === true) { add(project); }
        }).catch(function(e) {});
      }
    },
    mounted: function() {
      this.aInit();
    }
}

</script>
